// Language utility functions
export const languageUtils = {
  // Get current language from WPML
  getCurrentLanguage: (): string => {
    try {
      const pluginData = window.cdcargoJzkPlugin;

      // Only use WPML language if plugin data is available (production)
      if (pluginData?.language?.current) {
        return pluginData.language.current;
      }

      // Fallback to detecting from URL or HTML lang attribute
      const htmlLang = document.documentElement.lang;
      if (htmlLang) {
        return htmlLang.split('-')[0]; // Extract language code (e.g., 'en' from 'en-US')
      }

      // Default to Czech (for development or when WPML is not active)
      return 'cs';
    } catch (error) {
      console.warn('Could not get current language:', error);
      return 'cs';
    }
  },
};
